import React,{useEffect, useState} from "react";
import { Navigate, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import BaseUrl from '../Components/BaseUrl';
import Radio from '@mui/material/Radio';
import { styled } from '@mui/material/styles';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

const Onboardingstep5 = () => {
    const navigate = useNavigate();
    const [selectedOption, setSelectedOption] = useState("");
    const BpIcon = styled("span")(({ theme }) => ({
        borderRadius: "16px", 
        width: "100%", 
        padding: "10px 10px", 
        border: "2px solid #ccc",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.3s ease-in-out",
        backgroundColor: "#fff",
        cursor: "pointer",
        
        "input:hover ~ &": {
          border: "2px solid black",
        },
      
        "input:checked ~ &": {
          border: "5px solid #0A66C2", 
          backgroundColor: "#E8F0FE",
        }
      }));
      
      const BpCheckedIcon = styled(BpIcon)({
        border: "2px solid #0A66C2", 
        backgroundColor: "#E8F0FE",
      });
      
      function BpRadio(props) {
        return (
          <Radio
            disableRipple
            color="default"
            checkedIcon={<BpCheckedIcon />}
            icon={<BpIcon />}
            {...props}
          />
        );
      }
      

     const handleradiochange=(e)=>{
      setSelectedOption(e.target.value);
     }

    
    const handleSubmit=async(e)=>{
        e.preventDefault();
        if (selectedOption === "not-interested") {
          navigate("/user/onboarding/step6");
          return;
        } 

        if (selectedOption === "actively-looking"|| selectedOption === "open-opportunities") {
          window.localStorage.setItem("looking_for_job", 1);
          navigate("/user/onboarding/step6");
          return;
        }

    }
    
    
  return (
    <>
      <div className="flex flex-col items-center mt-14 justify-start min-h-screen bg-[#F3F2EF] py-10 px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-md text-center mb-4">
          <p className="text-2xl mb-2 ">Are you looking for a job?</p>
          <p className="text-[14px] text-gray-500">
            Your response is only visible to you
          </p>
        </div>

        <div className="w-full max-w-md flex flex-col items-center">
          <form className="w-full">
            <div className="mb-4 w-full">
              <FormControl className="">
                <RadioGroup
                value={selectedOption} onChange={handleradiochange}
                  aria-labelledby="demo-customized-radios"
                  name="customized-radios"
                >
                  <FormControlLabel
                    value="actively-looking"
                    control={<BpRadio />}
                    label="Yes, I'm actively looking for a new job"
                    className="MuiFormControlLabel-root w-full mb-2 border border-gray-400 rounded-lg p-3 hover:border-black transition"
                  />
                  <FormControlLabel
                    value="open-opportunities"
                    control={<BpRadio />}
                    label="Not really, but would consider the right opportunity"
                    className="w-full mb-2 border border-gray-400 rounded-lg p-3 hover:border-black transition"
                  />
                  <FormControlLabel
                    value="not-interested"
                    control={<BpRadio />}
                    label="No, I'm not interested in any job"
                    className="w-full mb-2 border border-gray-400 rounded-lg p-3 hover:border-black transition"
                  />
                </RadioGroup>
              </FormControl>
            </div>

            <div className="mt-8 flex justify-center">
              <button
                className="bg-[#0A66C2] hover:bg-blue-700 text-white font-bold py-2 px-4 h-12 rounded-full w-full"
                type="button"
                onClick={handleSubmit}
              >
                Next
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Onboardingstep5;
